<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-14 16:50:34
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-28 14:10:10
 -->
<template>
  <div class="login-container" @keyup.enter="handleLogin">
    <div class="login-weaper animated bounceInDown">
      <div class="login-left">
        <div class="login-time"> {{time}} </div>
        <img class="img" :src="website.logoAddress">
        <p class="title">{{website.loginText}}</p>
      </div>
      <div class="login-border">
        <div class="login-main">
          <h4 class="login-title">  {{website.loginText}} </h4>
         <!-- 登录组件  -->
          <userLogin v-if="activeName==='user'"></userLogin>
          <div class="login-menu">
            <a href="#" @click.stop="activeName='user'">账号密码</a>
            <a href="#" @click.stop="didTapToRetrievePassword">忘记密码</a>
            <a href="#" @click.stop="oauth2">统一身份认证</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { OAUTH2_CONFIG } from '@/page/config/base_config'
import userLogin from './userLogin'
import { mapGetters } from 'vuex'
import { dateFormat } from '@/framework/util/date'

export default {
  name: 'Login',
  components: {
    userLogin
  },
  data() {
    return {
      OAUTH2_CONFIG,
      time: '',
      activeName: 'user'
    }
  },
  created() {
    this.getTime()
    setInterval(() => {
      this.getTime()
    }, 1000)
  },
  computed: {
    ...mapGetters(['website'])
  },
  methods: {
    getTime() {
      this.time = dateFormat(new Date())
    },

    /** 跳转到密码找回页 */
    didTapToRetrievePassword: function() {
      this.$router.push({ path: '/findPassword' })
    },

    /** 统一身份认证登录 */
    oauth2: function() {
      // this.$http.get('/integrate/uaap/oauth2/authorize-url', { params: {
      //   responseType: 'code',
      //   scope: 'simple',
      //   redirectUrl: OAUTH2_CONFIG.FRONT_DEPLOYMENT_ADDRESS + '/oAuth2Login'
      // }}).then(response => {
      //   window.location.href = response.data
      // }).catch(error => {
      //   this.$message.error(error.msg)
      // })
      this.$router.push({ path: '/toCasLogin' })
    }
  }
}
</script>

<style lang="scss">
@import "@/framework/styles/login.scss";
.login-main{
  overflow: hidden;
}
</style>
